import React from 'react'
import { Link } from '@inertiajs/react'
import { formatPrice } from '../utils/formatters'

export default function EventTypeCard({ eventType, accountSlug }) {
  return (
    <Link
      href={`/${accountSlug}/booking/occasions/${eventType.slug}`}
      className="block bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow focus:outline-none focus:ring-2 focus:ring-sky-300"
    >
      {eventType.image_url ? (
        <img
          src={eventType.image_url}
          alt=""
          className="w-full aspect-[4/3] object-cover"
        />
      ) : (
        <div className="w-full aspect-[4/3] bg-sky-50 flex items-center justify-center">
          {eventType.icon && (
            <span className="text-2xl" aria-hidden="true">{eventType.icon}</span>
          )}
        </div>
      )}

      <div className="p-3">
        <h3 className="font-bold text-gray-900">{eventType.name}</h3>
        {eventType.from_price_pence != null && (
          <p className="text-xs text-gray-500 mt-0.5">
            From {formatPrice(eventType.from_price_pence)}
          </p>
        )}
      </div>
    </Link>
  )
}
